module.exports = __webpack_public_path__ + "media/images/charidy-background-1c569ca4e60adcdc1fbe16e1da36baf0.jpg";